export const prospectStatuses = [
    { id: 'pending', value: 'Pending' },
    { id: 'clear', value: 'Clear' },
    { id: 'consider', value: 'Consider' }
  ];
  


// WEBPACK FOOTER //
// ./src/constants/prospects.js